import React from "react";
import Quote from "./QuoteGen/Quote";

function App() {
  return (
    <div className="App">
      <Quote />
    </div>
  );
}

export default App;
